export default __webpack_public_path__ + "static/media/home-animation.8bbcc420.jpg";